var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.71627 3.127C3.16082 3.58798 3.01451 4.36828 2.72191 5.92886L2.22191 8.59555C1.81044 10.79 1.60471 11.8872 2.20452 12.6099C2.80433 13.3327 3.92069 13.3327 6.15339 13.3327H9.84731C12.08 13.3327 13.1964 13.3327 13.7962 12.6099C14.396 11.8872 14.1902 10.79 13.7788 8.59555L13.2788 5.92886C12.9862 4.36828 12.8399 3.58798 12.2844 3.127C11.729 2.66602 10.9351 2.66602 9.34731 2.66602H6.65339C5.06561 2.66602 4.27172 2.66602 3.71627 3.127Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00023 6.16745C7.34789 6.16745 6.79163 5.75077 6.58545 5.1675C6.49343 4.90714 6.20777 4.77068 5.94741 4.8627C5.68705 4.95473 5.55059 5.24039 5.64261 5.50074C5.98557 6.47106 6.91096 7.16748 8.00023 7.16748C9.08949 7.16748 10.0149 6.47106 10.3578 5.50074C10.4499 5.24039 10.3134 4.95473 10.053 4.8627C9.79269 4.77068 9.50703 4.90714 9.41503 5.1675C9.20883 5.75077 8.65256 6.16745 8.00023 6.16745Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag-icon.f1eb46b772ba1e231e0dfe988e0e5ee9.svg";
export { ForwardRef as ReactComponent };